import React, { useCallback, useState } from 'react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

// Parte H: el motivo es obligatorio al cambiar un umbral. Diálogo chico para los cambios en línea.
const MotivoCambioDialog = ({ pedido, onCerrar }) => {
  const [motivo, setMotivo] = useState('');
  const cerrar = (valor) => { setMotivo(''); onCerrar(valor); };
  return (
    <Dialog open={!!pedido} onOpenChange={(o) => !o && cerrar(null)}>
      <DialogContent className="max-w-md" data-testid="motivo-cambio-dialog">
        <DialogHeader>
          <DialogTitle>Motivo del cambio de umbral</DialogTitle>
          <DialogDescription>{pedido?.detalle}</DialogDescription>
        </DialogHeader>
        <Input autoFocus value={motivo} onChange={(e) => setMotivo(e.target.value)} data-testid="motivo-cambio-input"
          placeholder="Ej.: calibración por exceso de descartes" onKeyDown={(e) => e.key === 'Enter' && motivo.trim() && cerrar(motivo.trim())} />
        <DialogFooter>
          <Button variant="outline" onClick={() => cerrar(null)} data-testid="motivo-cambio-cancelar">Cancelar</Button>
          <Button disabled={!motivo.trim()} onClick={() => cerrar(motivo.trim())} data-testid="motivo-cambio-guardar"
            className="bg-sky-600 text-white hover:bg-sky-700">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// pedirMotivo(detalle) devuelve el motivo escrito o null si se canceló.
export const useMotivoCambio = () => {
  const [pedido, setPedido] = useState(null);
  const pedirMotivo = useCallback((detalle) => new Promise((resolve) => setPedido({ detalle, resolve })), []);
  const onCerrar = (valor) => { pedido?.resolve(valor); setPedido(null); };
  return [pedirMotivo, <MotivoCambioDialog pedido={pedido} onCerrar={onCerrar} />];
};

export default MotivoCambioDialog;
